import { useNavigate } from "react-router-dom";
import { UN_REGISTERED } from "../Constants";

// Custom hook to navigate to a user's profile
const useNavigateToProfile = () => {
  // Function to generate the profile URL based on the user's ID and role
  const profileUrl = (id, role) => {
    // If the user is registered, return the profile URL
    
    // if (role === "applicant") return `/user-profile?id=${id}`;
    // else if (role === "organization") return `/org-profile?id=${id}`;
    if (role && id && role !== UN_REGISTERED) return `/profile?id=${id}`;
    else return ""; // If the user is not registered, return an empty string
  };

  const navigate = useNavigate(); // Hook for navigation

  // Function to navigate to the user's profile
  const navigateToProfile = (id, role, isOpenTab = false) => {
    // If the user is registered
    if (role && id && role !== UN_REGISTERED) {
      // If isOpenTab is true, open the profile in a new tab
      if (isOpenTab) window.open(profileUrl(id, role), "_blank");
      else navigate(profileUrl(id, role)); // Otherwise, navigate to the profile in the current tab
    }
  };

  // Return the navigateToProfile function and the profileUrl function
  return { navigateToProfile, profileUrl };
};

export default useNavigateToProfile;
